import {Modal} from 'react-bootstrap';
import DOMPurify from 'dompurify';
import PropTypes from 'prop-types';
import Button from '../../../common/button';

const EmailPreview = ({onClose, show = false, children}) => (
  <div className="modal-container">

    <Modal show={show}>
      <Modal.Header>
        <Modal.Title>
          Email Preview
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(children)}} />
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={onClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  </div>
);

EmailPreview.propTypes = {
  show: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
};

export default EmailPreview;
